import React, { useEffect, useRef, useState } from 'react';
import LoginLogo from '../../../assets/page/login_logo.svg';
import LoginText from '../../../assets/page/login_text.svg';

const loginCircleLeft = `${process.env.PUBLIC_URL}/assets/page/login_circle_left.svg`;
const loginCircleMiddle = `${process.env.PUBLIC_URL}/assets/page/login_circle_middle.svg`;
const loginCircleRight = `${process.env.PUBLIC_URL}/assets/page/login_circle_right.svg`;

export const HeroSection: React.FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const element = containerRef.current;

    if (!element) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];

      if (entry) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

  const effectiveWidth = containerWidth || 640;
  const clampSize = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
  const circleContainerHeight = clampSize(effectiveWidth * 0.7, 320, 540);
  const effectiveHeight = circleContainerHeight;
  const baseLeft = clampSize(effectiveWidth * 0.06, 48, 96);
  const logoTop = clampSize(effectiveWidth * 0.04, 32, 96);
  const textTopSpacing = clampSize(effectiveWidth * 0.02, 15, 80);
  const logoWidth = clampSize(effectiveWidth * 0.28, 160, 260);
  const textWidth = clampSize(effectiveWidth * 0.62, 300, 560);
  const circleVerticalLift = clampSize((effectiveWidth - 1200) * 0.25, 0, 100);

  const circleConfigs = [
    {
      src: loginCircleLeft,
      alt: 'Community volunteer',
      sizeRatio: 0.36,
      minSize: 200,
      maxSize: 260,
      centerX: 0.12,
      centerY: 0.88,
      imageClass: 'object-cover',
    },
    {
      src: loginCircleMiddle,
      alt: 'Civic participation',
      sizeRatio: 0.32,
      minSize: 190,
      maxSize: 230,
      centerX: 0.5,
      centerY: 0.65,
      imageClass: 'object-cover',
    },
    {
      src: loginCircleRight,
      alt: 'Voting',
      sizeRatio: 0.42,
      minSize: 220,
      maxSize: 280,
      centerX: 0.9,
      centerY: 0.8,
      imageClass: 'object-contain',
    },
  ];

  return (
    <div className="hidden lg:flex lg:w-[50%] bg-[#eef9ef] dark:bg-[#0d2721] relative overflow-hidden flex-col">

      {/* Logo */}
      <div
        className="flex"
        style={{ marginTop: logoTop, marginLeft: baseLeft, width: logoWidth }}
      >
        <img 
          src={LoginLogo} 
          alt="CivicPoints Logo" 
          className="w-full h-auto"
        />
      </div>

      <div
        className="flex"
        style={{ marginTop: textTopSpacing, marginLeft: baseLeft, width: textWidth }}
      >
        <img 
          src={LoginText} 
          alt="CivicPoints Logo" 
          className="w-full h-auto"
        />
      </div>

      {/* Circular Images Container */}
      <div
        ref={containerRef}
        className="absolute bottom-10 left-0 right-0 w-full"
        style={{ height: circleContainerHeight }}
      >
        {circleConfigs.map((config) => {
          const size = clampSize(effectiveWidth * config.sizeRatio, config.minSize, config.maxSize);
          const left = effectiveWidth * config.centerX - size / 2;
          const top = effectiveHeight * config.centerY - size / 2 - circleVerticalLift;

          return (
            <div
              key={config.alt}
              className="absolute"
              style={{ width: size, height: size, left, top }}
            >
              <img
                src={config.src}
                alt={config.alt}
                className={`w-full h-full ${config.imageClass}`}
              />
            </div>
          );
        })}
      </div>

    </div>
  );
};
